import React from "react"
import { useParams } from "react-router-dom";
import { Badge, Box, CardBody, CardHeader, Divider, VStack } from "@chakra-ui/react";
import { SettingItem } from "../../organisms/SettingItem";
import { DarkShadowCard } from "../../molecules/card/DarkShadowCard";
import { CardHeading } from "../../molecules/card/CardHeading";
import { SettingsIcon } from "@chakra-ui/icons";
import { CircularLoading } from "../../molecules/loading/CircularLoading";
import { RestaurantSettingCardFooter } from "../../organisms/restaurant/RestaurantSettingCardFooter";
import { useFetchStaffSettingByRestaurantId } from "../../../hooks/restaurantStaff/useFetchStaffSettingByRestaurantId";


export const StaffSetting = () => {
  const { restaurantId } = useParams();
  const {staffSetting, isLoading} = useFetchStaffSettingByRestaurantId(restaurantId);
  if (isLoading) return <CircularLoading />;
  const path = staffSetting ? `${staffSetting?.id}/edit` : `register`;
  const settingItems = [
    {label: '店舗ブランチスコア', content: staffSetting?.restaurant_branch_score ?? '未登録'},
    {label: '店舗ブランチクエッション', content: staffSetting?.restaurant_branch_question_name ?? '未登録'},
    {label: '従業員ブランチスコア', content: staffSetting?.staff_branch_score ?? '未登録'},
    {label: '従業員ブランチクエッション', content: staffSetting?.staff_branch_question_name ?? '未登録'},
    {label: '遷移先URL', content: staffSetting?.g_url ?? '未登録'},
    {label: '遷移先URLへの遷移', content: staffSetting?.is_navigate_g_url ? <Badge colorScheme='green'>ON</Badge> : <Badge colorScheme='gray'>OFF</Badge>},
  ];
  return (
    <DarkShadowCard w='100%'>
      <CardHeader pb={0}>
        <CardHeading icon={<SettingsIcon />} heading='スタッフ設定'/>
      </CardHeader>
      <CardBody>
        <VStack align='start' fontSize='sm' fontWeight='bold' spacing={4} w='100%'>
          <Divider my={0} />
          {settingItems.map((detail) => (
            <React.Fragment key={detail.label}>
              <Box w='100%'>
                <SettingItem label={detail.label} content={detail.content}/>
              </Box>
              <Divider my={0} />
            </React.Fragment>
          ))}
        </VStack>
      </CardBody>
      <RestaurantSettingCardFooter path={path} />
    </DarkShadowCard>
  );
};